import { Link } from 'react-router-dom';

const services = [
  {
    title: 'Mobile Lawn Mower Repair',
    description:
      'Expert repair and maintenance for push and riding mowers. We come to your property and get it running right — no hauling, same-day service when possible.',
    href: '/services/lawn-mower',
    image:
      'https://roadtechservices.netlify.app/images/mower-repair-1-850w.jpeg',
    tag: 'Lawn Mowers',
  },
  {
    title: 'Snow Blower Repair & Maintenance',
    description:
      'Stay ready for Michigan winters with certified snow blower repair, tune-ups, and seasonal maintenance — all performed at your doorstep.',
    href: '/services/snow-blower',
    image:
      'https://roadtechservices.netlify.app/images/snowblower_0-850w.jpeg',
    tag: 'Snow Blowers',
  },
  {
    title: 'Generator Repair & Service',
    description:
      'Never be left without power. Our certified technician services portable and standby generators on-site, keeping your backup power reliable when it counts.',
    href: '/services/generator',
    image:
      'https://roadtechservices.netlify.app/images/generator-repair-1-850w.jpeg',
    tag: 'Generators',
  },
];

export default function ServicesSection() {
  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <p className="text-orange-600 text-xs font-bold uppercase tracking-widest mb-3">
              What We Do
            </p>
            <h2 className="font-display text-4xl lg:text-5xl font-bold uppercase tracking-tight text-neutral-900">
              Three Services.
              <br className="hidden lg:block" /> One Expert Technician.
            </h2>
          </div>
          <p className="text-neutral-500 text-sm leading-relaxed max-w-sm">
            Everything your outdoor power equipment needs — serviced right at
            your home by a certified technician.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {services.map((service) => (
            <Link
              key={service.href}
              to={service.href}
              className="group relative overflow-hidden rounded-2xl cursor-pointer block"
              data-product-shop
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="inline-block bg-orange-600 text-white text-xs font-semibold px-3 py-1 rounded-full mb-3">
                  {service.tag}
                </span>
                <h3 className="font-display text-xl font-bold text-white uppercase tracking-tight mb-2 leading-tight">
                  {service.title}
                </h3>
                <p className="text-white/70 text-xs leading-relaxed mb-4">
                  {service.description}
                </p>
                <div className="flex items-center gap-2 text-orange-400 text-xs font-semibold group-hover:gap-3 transition-all">
                  Learn More
                  <i className="ri-arrow-right-line" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
